import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const ResetPasswordDialog = ({ target }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) return setError(t("passwordMismatch"));
    try {
      await api.put(`/users/${target.id}/password`, { new_password: pwd });
      toast.success(t("passwordChanged"));
      setOpen(false);
    } catch (err) { setError(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setPwd(""); setConfirm(""); setError(""); }}>
      <DialogTrigger asChild>
        <Button size="sm" variant="ghost" data-testid={`employee-reset-${target.email}`}><KeyRound className="w-4 h-4" /></Button>
      </DialogTrigger>
      <DialogContent data-testid="reset-password-dialog">
        <DialogHeader><DialogTitle>{t("resetPassword")} · {target.name}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-slate-500" dir="ltr">{target.email}</p>
          <div className="space-y-1.5"><Label>{t("newPassword")}</Label>
            <Input type="password" dir="ltr" minLength={6} required data-testid="rp-new-input" value={pwd} onChange={(e) => setPwd(e.target.value)} /></div>
          <div className="space-y-1.5"><Label>{t("confirmPassword")}</Label>
            <Input type="password" dir="ltr" minLength={6} required data-testid="rp-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
          {error && <p className="text-sm text-rose-600" data-testid="rp-error">{error}</p>}
          <DialogFooter><Button type="submit" data-testid="rp-submit-btn">{t("save")}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
